<template>
    <div class="component-wrap">
        <HeaderMenu :menuVisible="false" />
        <main class="page centered">
            <h1 class="form__title">{{$t("Новый пароль отправлен на Вашу почту")}}</h1>
            <form class="form">
                <ButtonRed type="button" class=" btn--big" @click.native="post_email()">{{$t("Отправить повторно")}}</ButtonRed>
                <v-layout class="form__row justify-center">
                    <greenLink @click.native="go_to_auth">{{$t("Авторизация")}}</greenLink>
                </v-layout>
                <!-- <ModalRecover ref="modal" /> -->
            </form>
        </main>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ButtonRed from '@/components/ui/buttons/button_red.vue';
import greenLink from '@/components/ui/links/styled/link_green.vue';
import HeaderMenu from '@/components/blocks/common/Header_menu.vue';
import api from '@/api/index';


export default {
  components: {
    ButtonRed,
    greenLink,
    HeaderMenu,
  },
  computed: {
    ...mapGetters('autorisation', ['email_recover']),

  },
  methods: {
    go_to_auth() {
      window.history.replaceState(0, '/pwd_recover', '/');
      window.history.replaceState(0, '/recover_true', '/');
      this.$router.push({name: 'auth'});
    },
    async post_email() {
      if (!this.email_recover) {
        this.valid = false;
      } else {
        try {
          const res = await api.user.forgot_pass(this.email_recover);
          if (res.data.message.length ) {
            this.valid = true;
            this.$router.push({name: 'recover_true'});
          } else {
            this.valid = false;
          }
        } catch (err) {
          if (err.message.indexOf('401')!=-1) {
            this.$router.push({name: 'auth'});
            localStorage.clear();
          }
        }
      }
    },
  },
};
</script>
